import store from '../store'

export function authGuard (routes)
{
    return guard(routes, (to, from, next) => {
        if (store.getters.authLoggedIn) {
            next()
        } else {
            localStorage.setItem('previousRoute', to.path)
            next({ name: 'login' })
        }
    })
}


export function guestGuard (routes)
{
    return guard(routes, (to, from, next) => {
      if (store.getters.authLoggedIn) {
          next({ name: 'home' })
      } else {
          next()
      }
    })
}

function guard (routes, guard)
{
  routes.forEach(route => { route.beforeEnter = guard })

  return routes
}


// WEBPACK FOOTER //
// ./src/router/utils.js